import React, { Component } from 'react';
import './Carousel.scss';

export default class Carousel extends Component {
  //constructor(props) {
  //  super(props);
  //  this.state = {organization_name: undefined, organization_id: undefined}
  //}

  componentDidMount() {
    //console.log('carousel about to init');
    //console.log( $(this.refs.carousel) );
    //$(this.refs.carousel).jcarousel();
    $('#tech-carousel').jcarousel();
  }

  renderItems() {
    return this.props.opts.items.map(function(item, i) {
      return (
        <li key={i}>
          <span className="logo-img">
            <img src={item.icon} alt="" />
          </span>
          <span className="txt">
            {item.name}
          </span>
        </li>
      );
    })
  }

  render() {
    return (
      <div ref="carousel" className="carusel">
        <ul id="tech-carousel" className="jcarousel-skin-tango">
          {this.renderItems()}
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Carousel.js